import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import auth from '../../services/auth/auth'

// Authentication guard
export const requireAuth = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  if (!auth.isAuthenticated()) {
    // Save the original URL including query parameters
    const targetUrl = to.fullPath
    next({
      path: '/login',
      query: { redirect: targetUrl }
    })
  } else {
    next()
  }
}

// Already authenticated guard (for login page)
export const redirectIfAuth = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  if (auth.isAuthenticated()) {
    next({ path: '/' })
  } else {
    next()
  }
}
